'use client'

import { Spacer, Button, Text } from '@vinted/web-ui'

import { useAsset } from '@marketplace-web/shared/assets'
import { navigateToPage } from '@marketplace-web/browser/browser-navigation-util'

import { useSession } from '@marketplace-web/shared/session-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { MEMBER_PROFILE_URL } from '../../../constants/routes'

const AddVatFormSuccess: React.FC = () => {
  const { user } = useSession()
  const asset = useAsset()
  const translate = useTranslate()
  const handleGoToProfile = () => {
    if (user) {
      navigateToPage(MEMBER_PROFILE_URL(user.id))
    }
  }

  return (
    <>
      <img
        className="pro-integrations-application_form-success-icon"
        src={asset('check-circle.svg')}
        alt="success check circle"
        height={96}
      />
      <Spacer size="medium" />
      <div className="u-text-center">
        <Text as="h2" type="heading">
          {translate('business.add_vat_page.success.title')}
        </Text>
        <Spacer size="large" />
        <Text as="p">{translate('business.add_vat_page.success.content')}</Text>
        <Spacer size="x2-large" />

        <Button
          theme="primary"
          text={translate('business.add_vat_page.success.button')}
          styling="filled"
          onClick={handleGoToProfile}
        />
      </div>
    </>
  )
}

export default AddVatFormSuccess
